import { render, staticRenderFns } from "./receive-coupon.vue?vue&type=template&id=0ff65e60&scoped=true&"
import script from "./receive-coupon.vue?vue&type=script&lang=js&"
export * from "./receive-coupon.vue?vue&type=script&lang=js&"
import style0 from "./receive-coupon.vue?vue&type=style&index=0&id=0ff65e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff65e60",
  null
  
)

export default component.exports